"use client";
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { languageMap } from "../../../../../../../../constants/language.js";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXxs, FontSize600 } from "@nxt-costco-com/forge-design-tokens";
import { getFormattedPrice } from "./lib.js";
import { StyledPriceSpan, StyledHiddenSpan, StyledPriceSpanDefault } from "./styles.js";
const COMPONENT_NAME = "Price";
const Price = (props) => {
  const { priceText, priceValue, locale, uniqueId } = props || {};
  const isFrench = locale === languageMap["-25"];
  if (!priceValue) return null;
  let formattedPrice, symbol;
  let superScript = [];
  if (Array.isArray(priceValue) && priceValue.length === 2) {
    formattedPrice = priceValue.map(
      (price) => getFormattedPrice(price, locale)
    );
    if (isFrench) {
      symbol = formattedPrice[0].slice(-1);
      formattedPrice[0] = formattedPrice[0].substring(0, formattedPrice[0].length - 1).trim();
      formattedPrice[1] = formattedPrice[1].substring(0, formattedPrice[1].length - 1).trim();
    } else {
      symbol = formattedPrice[0].substring(0, 1);
      formattedPrice[0] = formattedPrice[0].substring(1);
      formattedPrice[1] = formattedPrice[1].substring(1);
    }
    let superscriptedPrice;
    if (isFrench) {
      superscriptedPrice = formattedPrice.flatMap(
        (price) => price.split(",")
      );
    } else {
      superscriptedPrice = formattedPrice.flatMap(
        (price) => price.split(".")
      );
    }
    superScript = [...superscriptedPrice];
  } else {
    formattedPrice = priceText ? `${priceText} ${getFormattedPrice(priceValue, locale)}` : getFormattedPrice(priceValue, locale);
    if (isFrench) {
      symbol = formattedPrice.slice(-1);
      formattedPrice = formattedPrice.substring(0, formattedPrice.length - 1).trim();
    } else {
      symbol = formattedPrice.substring(0, 1);
      formattedPrice = formattedPrice.substring(1);
    }
    if (formattedPrice.includes(".")) {
      const splitPrice = formattedPrice.split(".");
      superScript = [...splitPrice];
    }
    if (isFrench && formattedPrice.includes(",")) {
      const splitPrice = formattedPrice.split(",");
      superScript = [...splitPrice];
    }
  }
  if (superScript.length > 2) {
    if (isFrench) {
      return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
        Text,
        {
          sx: {
            alignItems: "flex-start",
            display: "flex",
            flexWrap: "wrap",
            fontSize: FontSize600,
            gap: SpaceXxs,
            lineHeight: 1.2,
            marginBottom: SpaceXxs,
            width: "100%"
          },
          bold: true,
          uniqueId: `${COMPONENT_NAME}_${uniqueId}`,
          variant: "t1/mobile",
          children: [
            /* @__PURE__ */ jsxs("p", { children: [
              superScript[0],
              /* @__PURE__ */ jsxs(StyledPriceSpan, { children: [
                /* @__PURE__ */ jsx(StyledHiddenSpan, { children: "," }),
                superScript[1]
              ] }),
              /* @__PURE__ */ jsx(StyledPriceSpan, { isFrench: true, children: symbol })
            ] }),
            /* @__PURE__ */ jsx("p", { children: "-" }),
            /* @__PURE__ */ jsxs("p", { children: [
              superScript[2],
              /* @__PURE__ */ jsx(StyledHiddenSpan, { children: "," }),
              /* @__PURE__ */ jsx(StyledPriceSpan, { children: superScript[3] }),
              /* @__PURE__ */ jsx(StyledPriceSpan, { isFrench: true, children: symbol })
            ] })
          ]
        }
      ) });
    }
    return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
      Text,
      {
        sx: {
          alignItems: "flex-start",
          display: "flex",
          flexWrap: "wrap",
          fontSize: FontSize600,
          gap: SpaceXxs,
          lineHeight: 1.2,
          marginBottom: SpaceXxs,
          width: "100%"
        },
        bold: true,
        uniqueId: `${COMPONENT_NAME}_${uniqueId}`,
        variant: "t1/mobile",
        children: [
          /* @__PURE__ */ jsxs("p", { children: [
            /* @__PURE__ */ jsx(StyledPriceSpan, { children: symbol }),
            superScript[0],
            /* @__PURE__ */ jsxs(StyledPriceSpan, { children: [
              /* @__PURE__ */ jsx(StyledHiddenSpan, { children: "." }),
              superScript[1]
            ] })
          ] }),
          /* @__PURE__ */ jsx("p", { children: "-" }),
          /* @__PURE__ */ jsxs("p", { children: [
            /* @__PURE__ */ jsx(StyledPriceSpan, { children: symbol }),
            superScript[2],
            /* @__PURE__ */ jsx(StyledHiddenSpan, { children: "." }),
            /* @__PURE__ */ jsx(StyledPriceSpan, { children: superScript[3] })
          ] })
        ]
      }
    ) });
  }
  if (superScript.length) {
    if (isFrench) {
      return /* @__PURE__ */ jsx(
        Text,
        {
          sx: {
            alignItems: "flex-start",
            display: "flex",
            flexWrap: "wrap",
            fontSize: FontSize600,
            lineHeight: 1.2,
            marginBottom: SpaceXxs,
            width: "100%"
          },
          bold: true,
          uniqueId: `${COMPONENT_NAME}_${uniqueId}`,
          variant: "t1/mobile",
          children: /* @__PURE__ */ jsxs("p", { children: [
            superScript[0],
            /* @__PURE__ */ jsx(StyledHiddenSpan, { children: "," }),
            /* @__PURE__ */ jsx(StyledPriceSpan, { children: superScript[1] }),
            /* @__PURE__ */ jsx(StyledPriceSpan, { isFrench: true, children: symbol })
          ] })
        }
      );
    }
    return /* @__PURE__ */ jsx(
      Text,
      {
        sx: {
          alignItems: "flex-start",
          display: "flex",
          flexWrap: "wrap",
          fontSize: FontSize600,
          lineHeight: 1.2,
          marginBottom: SpaceXxs,
          width: "100%"
        },
        bold: true,
        uniqueId: `${COMPONENT_NAME}_${uniqueId}`,
        variant: "t1/mobile",
        children: /* @__PURE__ */ jsxs("p", { children: [
          /* @__PURE__ */ jsx(StyledPriceSpan, { children: symbol }),
          superScript[0],
          /* @__PURE__ */ jsx(StyledHiddenSpan, { children: "." }),
          /* @__PURE__ */ jsx(StyledPriceSpan, { children: superScript[1] })
        ] })
      }
    );
  }
  return /* @__PURE__ */ jsxs(
    Text,
    {
      sx: {
        fontSize: FontSize600,
        lineHeight: 1.2,
        marginBottom: SpaceXxs,
        width: "100%"
      },
      bold: true,
      uniqueId: `${COMPONENT_NAME}_${uniqueId}`,
      variant: "t1/mobile",
      children: [
        /* @__PURE__ */ jsx(StyledPriceSpanDefault, { children: symbol }),
        formattedPrice
      ]
    }
  );
};
Price.displayName = COMPONENT_NAME;
export {
  Price
};
